import { QueryFeature } from '../../../config/queryClient';
import { ClientType } from '../ClientSearch.meta';

enum QueryKey {
  SearchClients = 'SearchClients',
  ClientList = 'ClientList',
}

export const queryKeys = {
  clientListAll: () => [QueryFeature.ClientList],

  searchClients: (term: string, type: string | null) => [
    QueryFeature.ClientList,
    QueryKey.SearchClients,
    term,
    type,
  ],

  clientList: (term?: string, clientType?: ClientType) => [
    QueryFeature.ClientList,
    QueryFeature.ClientList,
    term,
    clientType,
  ],
};
